import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Tabs, Tab, AppBar, Grid } from "@material-ui/core";

import AddressingMapView from "./AddressingMapView";
import AddressingMapViewOption2 from "./AddressingMapViewOption2";
import AddressingMapViewOption3 from "./AddressingMapViewOption3";

import Drawer from "@material-ui/core/Drawer";
import { useSelector, useDispatch } from "react-redux";
import {
  setSidePanelopen,
  setSidePanelResultType,
} from "../../redux/actions/mapPanelControlActions";

import "../../App.css";
import IssuesInbox from "../AddressIssues/IssuesInbox";
import AddressDetailsPane from "../AddressResult/AddressDetailsPane";
import { useTranslation } from "react-i18next";
import { IconButton } from "@material-ui/core";
import OpenPanel from "@material-ui/icons/ArrowRight";
import ClosePanel from "@material-ui/icons/ArrowLeft";
import ReactGA from "react-ga";

// import "../App.css";
let drawerWidth =
  document.body.offsetWidth > 400 ? 400 : document.body.offsetWidth;
let sideFlag = document.body.offsetWidth > 400 ? true : false;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
  },
  root2: {
    flexGrow: 1,
    maxWidth: 500,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    height: "100%",
  },
  drawerPaper: {
    width: drawerWidth,
    top: "auto",
    height: "calc(100vh - 69px)",
    boxShadow: "0 0 35px rgb(0 0 0 / 35%)",
  },
  drawerHeader: {
    // display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    backgroundColor: theme.palette.primary.light,
    // backgroundColor: "#453c90",
    // necessary for content to be below app bar
    //...theme.mixins.toolbar,
    // justifyContent: "flex-end",
  },
  indicator: {
    backgroundColor: "lightgrey",
    display: "none",
  },
  content: {
    flexGrow: 1,
    // padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
    height: "100%",
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  contentRtl: {
    flexGrow: 1,
    // padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
    height: "100%",
  },
  contentShiftRtl: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  section1: {
    margin: theme.spacing(3, 2),
  },
  section2: {
    margin: theme.spacing(2),
  },
  section3: {
    margin: theme.spacing(3, 1, 1),
  },
  items: {
    padding: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

function MapWrapper(props) {
  const classes = useStyles();
  const { t, i18n } = useTranslation("mapPage");
  // const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings);
  const panelProps = useSelector((state) => state.mapPanelSetting);
  const theme = useTheme();
  useEffect(() => {
    dispatch(setSidePanelopen(sideFlag));
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const handleDrawerClose = () => {
    // setOpen(false);
    dispatch(setSidePanelopen(false));
  };

  const handleTabChange = (event, type) => {
    dispatch(setSidePanelResultType(type));
  };

  return (
    <div className={classes.root}>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor={settings.language === "en" ? "left" : "right"}
        open={panelProps.isSidePanelOpen}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <Grid container>
            <Grid item xs={10} md={10} lg={10}>
              <Tabs
                value={panelProps.resultType}
                onChange={handleTabChange}
                variant="fullWidth"
                classes={{ indicator: classes.indicator }}
                style={{ color: "#ffffff" }}
              >
                <Tab label={t("AddressTab")} value="address" />
                {settings.userCredentials &&
                settings.userCredentials?.user?.roleNames.includes(
                  "Addressing_Custodian"
                ) ? (
                  <Tab label={t("IssueInboxTab")} value="issue" />
                ) : (
                  ""
                )}
              </Tabs>
            </Grid>
            <Grid item xs={2} md={2} lg={2}>
              <IconButton
                aria-label="Search"
                style={{ color: "white" }}
                onClick={() => handleDrawerClose(false)}
              >
                {settings.language == "en" ? <ClosePanel /> : <OpenPanel />}
              </IconButton>
            </Grid>
          </Grid>
        </div>
        {panelProps.resultType == "address" ? (
          // <AddressResultPane />
          <AddressDetailsPane />
        ) : (
          <IssuesInbox />
        )}
      </Drawer>
      <main
        className={clsx(
          settings.language === "en" ? classes.content : classes.contentRtl,
          {
            [settings.language === "en"
              ? classes.contentShift
              : classes.contentShiftRtl]: panelProps.isSidePanelOpen,
          }
        )}
      >
        {/* #For-MapOptions */}
        {/* {props.showMap === 1 ? <AddressingMapView /> : <></>}
        {props.showMap === 2 ? <AddressingMapViewOption2 /> : <></>}
        {props.showMap === 3 ? <AddressingMapViewOption3 /> : <></>} */}

        <AddressingMapView showMap={props.showMap} />
        {/* <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Share Address</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To share address to your email, please enter your email address here
            and click share.
          </DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            label="Email Address"
            type="email"
            onInput={(e) => setEmail(e.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleShare} color="primary">
            Share
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={reportOpen}
        onClose={handleReportClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Report Issue</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To report an issue, please fill up the below details and click
            Report.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="email"
            label="Email Address"
            type="email"
            fullWidth
          />
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Phone number"
            type="Phone"
            fullWidth
          />
          <TextField
            autoFocus
            margin="dense"
            id="issueType"
            select
            label="Issue Type"
            value={issueTypes}
            fullWidth
          >
            {issueTypes.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReportClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleReportClose} color="primary">
            Report
          </Button>
        </DialogActions>
      </Dialog> */}
      </main>
    </div>
  );
}

export default MapWrapper;
